exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2eO__3UnNeKZ3JyDKa4xEP {\n  position: absolute;\n  bottom: 0;\n  height: 70px;\n  width: 362px;\n  background-color: #efefef;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n", ""]);

// exports
exports.locals = {
	"confirmPanelWrapper": "_2eO__3UnNeKZ3JyDKa4xEP"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/containers/IDTFRecordingReviewPane/IDTFRecordingReviewPane.css
// module id = 10215
// module chunks = 23